// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container","error":"Checkbox_error","input":"Checkbox_input","label":"Checkbox_label","large":"Checkbox_large","noCheckbox":"Checkbox_noCheckbox"};